<script lang="ts" module>
	export interface SearchTopBarProps {
		onClickBack: () => void;
		children?: import('svelte').Snippet;
	}
</script>

<script lang="ts">
	import { ChevronLeftIcon } from '../../../../assets/icons/ChevronLeftIcon';
	const dataCyPrefix = 'search-top-bar';

	let { onClickBack, children }: SearchTopBarProps = $props();
</script>

<div class="flex h-full w-full items-center justify-center search-top-bar">
	<button
		type="button"
		onclick={onClickBack}
		data-cy={`${dataCyPrefix}-back`}
		class="mt-[0.1875rem] ml-0.5 outline-none"
		aria-label="Close search"
	>
		<ChevronLeftIcon class="h-5 w-5" />
	</button>
	{@render children?.()}
</div>

<style>
	:global(.search-top-bar > form > input) {
		background-color: white;
	}
</style>
